import React, { Component } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Button, Row, Col } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';

// koneksi
import { Get, } from '../../../function/Koneksi';

import Datetime from 'react-datetime';

// css files
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import classnames from 'classnames';

import BootstrapTable from 'react-bootstrap-table-next';

const dateFormat = require('dateformat');

class BasicTable extends Component {
  _isMounted = false;
	constructor(props) {
		super(props);
		this.state = {
      // DATA LOG BSRE
        dataLogBSRE: [],
        paginationLogBSRE: [],
        statusLogBSRE: {
          form: false,
          btnForm: false,
          btnAksi: false,
          disKode: "inherit"
        },
        awalLogBSRE: "",
        sebelumLogBSRE: "",
        halLogBSRE: [],
        setelahLogBSRE: "",
        akhirLogBSRE: "",
        dtLogBSRE: null,
        loadingLogBSRE: false,
        // Cari Data
        textCari: '',
        // Filter Data
        filterData: new Date(),
        filterMonth: dateFormat(new Date(), 'mm'),
        filterYear: dateFormat(new Date(), 'yyyy'),
      // END DATA LOG BSRE

      // DATA DETAIL LOG BSRE
      statDetailLogBSRE: false,
      detailDataLogBSRE: null,
      loadingDetailLogBSRE: false,
      // END DATA DETAIL LOG BSRE

      // DATA LOG EXPORT
      dataLogExport: [],
      paginationLogExport: [],
      statusLogExport: {
        form: false,
        btnForm: false,
        btnAksi: false,
        disKode: "inherit"
      },
      awalLogExport: "",
      sebelumLogExport: "",
      halLogExport: [],
      setelahLogExport: "",
      akhirLogExport: "",
      dtLogExport: null,
      loadingLogExport: false,
      // END DATA LOG EXPORT
     
      alert: null,
      show: false,
      loading: false,
      loadingPreview: false,
      basicTitle: '',
      basicType: 'default',
      pesanAlert: '',
			
      // Tab Status
      active_tab_vertical: '1',
      active_tab_icon: '1',
		};
	}

	// ================== Sweet Alert ==================
	closeAlert = () => {
		this.setState({
			show: false
		});
	};

	onRecieveInput = (value) => {
		this.setState({
			alert: (
				<SweetAlert success title="Nice!" onConfirm={this.hideAlert}>
					You wrote: {value}
				</SweetAlert>
			)
		});
	};

	hideAlert = () => {
		this.setState({
			alert: null
		});
	};

	// =================================================

	// Toggle Vertical Tab
	toggle_vertical(tab) {
      if (this.state.active_tab_vertical !== tab) {
        this.setState({
            active_tab_vertical: tab,
            active_tab_icon: '1',
            statDetailLogBSRE: false,
            detailDataLogBSRE: null,
            textCari: '',
            filterData: new Date(),
            filterMonth: dateFormat(new Date(), 'mm'),
            filterYear: dateFormat(new Date(), 'yyyy'),
        });
      }
  }

  // LOG BSRE
    fetchDataLogBSRE = (params = {}) => {
      this.setState({ loadingLogBSRE: true })
      let link = "";
      
      if (params.page) {
        switch (params.page) {
          case ">>":
            link =
              "&page=" +
              Math.ceil(
                this.state.paginationLogBSRE.total / this.state.paginationLogBSRE.per_page
              );
            break;
          case ">":
            link = "&page=" + (parseInt(this.state.paginationLogBSRE.current_page) + 1);
            break;
          case "<":
            link = "&page=" + (parseInt(this.state.paginationLogBSRE.current_page) - 1);
            break;
          case "<<":
            link = "&page=1";
            break;
          default:
            link = "&page=" + params.page;
            break;
        }
      }


      if (this.state.textCari !== '') {
        link = link + '&q=' + this.state.textCari
      }
      
      Get("log-bsre?month=" + params.month + "&years=" + params.year + link, null, showDt => {
        if(showDt.results){
            this.setState({ dataLogBSRE: showDt.results.data, paginationLogBSRE: showDt.results, loadingLogBSRE: false });
            this.paginationLogBSRE(showDt.results);
        }
      });
    };

    // paginationLogBSRE
    paginationLogBSRE = data => {
      let awalLogBSRE = "";
      let halLogBSRE = [];
      let sebelumLogBSRE = "";
      let setelahLogBSRE = "";
      let akhirLogBSRE = "";
      if (data.total > 0) {
        let start = 1;
        let end = 5;
        let n = 0;
        let p = 0;
        if (data.current_page <= 3) {
          start = 1;
          end = 5;
          if (data.last_page > data.current_page) {
            n = data.current_page + 1;
          }
        } else {
          p = data.current_page - 1;
          n = data.current_page + 1;
          start = data.current_page - 2;
          end = data.current_page + 2;
        }
        if (end >= data.last_page - 2) {
          p = data.current_page - 1;
          if (start >= 5) {
            start = data.last_page - 4;
          }
          end = data.last_page;
        }

        for (let i = start; i <= end; i++) {
          let warna = "primary-custom";
          if (i === data.current_page) {
            warna = "danger";
          }
          halLogBSRE.push(
            <a
              href={() => false}
              onClick={() => this.fetchDataLogBSRE({ page: i, month: this.state.filterMonth, year: this.state.filterYear })}
              className={
                "btn btn-" + warna + " btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
              }
            >
              {i}
            </a>
          );
        }
        if (p > 0) {
          sebelumLogBSRE = (
            <a
              href={() => false}
              onClick={() => this.fetchDataLogBSRE({ page: p, month: this.state.filterMonth, year: this.state.filterYear })}
              className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
            >
              {"<"}
            </a>
          );
        }
        if (n > 0) {
          setelahLogBSRE = (
            <a
              href={() => false}
              onClick={() => this.fetchDataLogBSRE({ page: n, month: this.state.filterMonth, year: this.state.filterYear })}
              className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
            >
              {">"}
            </a>
          );
        }
        awalLogBSRE = (
          <a
            href={() => false}
            onClick={() => this.fetchDataLogBSRE({ page: 1, month: this.state.filterMonth, year: this.state.filterYear })}
            className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
          >
            {"<<"}
          </a>
        );
        akhirLogBSRE = (
          <a
            href={() => false}
            onClick={() => this.fetchDataLogBSRE({ page: data.last_page, month: this.state.filterMonth, year: this.state.filterYear })}
            className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
          >
            {">>"}
          </a>
        );
      }
      this.setState({ awalLogBSRE, sebelumLogBSRE, halLogBSRE, setelahLogBSRE, akhirLogBSRE });
    };

    tombolAksiLogBSRE = (cell, row) => {
      return (
        <>
          <Button
            size="xs"
            color="info"
            className="btn-icon"
            title="Detail Log"
            onClick={() => {
              this.setState({
                loadingDetailLogBSRE: true,
              })
              this.detailDataLogBSRE(row)
            }}
          >
            <i className="fa fa-eye"></i>
          </Button>{" "}
        </>
      );
    };
  // END LOG BSRE

  // DETAIL LOG BSRE
  detailDataLogBSRE = (data) => {
    this.setState({
        loadingDetailLogBSRE: false,
        statDetailLogBSRE: true,
        detailDataLogBSRE: data,
    })
    this.forceUpdate();
  }
  // END DETAIL LOG BSRE

  
  // LOG Export
  fetchDataLogExport = (params = {}) => {
    this.setState({ loadingLogExport: true })
    let link = "";
    
    if (params.page) {
      switch (params.page) {
        case ">>":
          link =
            "&page=" +
            Math.ceil(
              this.state.paginationLogExport.total / this.state.paginationLogExport.per_page
            );
          break;
        case ">":
          link = "&page=" + (parseInt(this.state.paginationLogExport.current_page) + 1);
          break;
        case "<":
          link = "&page=" + (parseInt(this.state.paginationLogExport.current_page) - 1);
          break;
        case "<<":
          link = "&page=1";
          break;
        default:
          link = "&page=" + params.page;
          break;
      }
    }


    if (this.state.textCari !== '') {
      link = link + '&q=' + this.state.textCari
    }
    
    Get("riwayat-export?month=" + params.month + "&years=" + params.year + link, null, showDt => {
      if(showDt.results){
        this.setState({ dataLogExport: showDt.results.data, paginationLogExport: showDt.results, loadingLogExport: false });
        this.paginationLogExport(showDt.results);
      }
    });
  };

  // paginationLogExport
    paginationLogExport = data => {
      let awalLogExport = "";
      let halLogExport = [];
      let sebelumLogExport = "";
      let setelahLogExport = "";
      let akhirLogExport = "";
      if (data.total > 0) {
        let start = 1;
        let end = 5;
        let n = 0;
        let p = 0;
        if (data.current_page <= 3) {
          start = 1;
          end = 5;
          if (data.last_page > data.current_page) {
            n = data.current_page + 1;
          }
        } else {
          p = data.current_page - 1;
          n = data.current_page + 1;
          start = data.current_page - 2;
          end = data.current_page + 2;
        }
        if (end >= data.last_page - 2) {
          p = data.current_page - 1;
          if (start >= 5) {
            start = data.last_page - 4;
          }
          end = data.last_page;
        }

        for (let i = start; i <= end; i++) {
          let warna = "primary-custom";
          if (i === data.current_page) {
            warna = "danger";
          }
          halLogExport.push(
            <a
              href={() => false}
              onClick={() => this.fetchDataLogExport({ page: i, month: this.state.filterMonth, year: this.state.filterYear })}
              className={
                "btn btn-" + warna + " btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
              }
            >
              {i}
            </a>
          );
        }
        if (p > 0) {
          sebelumLogExport = (
            <a
              href={() => false}
              onClick={() => this.fetchDataLogExport({ page: p, month: this.state.filterMonth, year: this.state.filterYear })}
              className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
            >
              {"<"}
            </a>
          );
        }
        if (n > 0) {
          setelahLogExport = (
            <a
              href={() => false}
              onClick={() => this.fetchDataLogExport({ page: n, month: this.state.filterMonth, year: this.state.filterYear })}
              className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
            >
              {">"}
            </a>
          );
        }
        awalLogExport = (
          <a
            href={() => false}
            onClick={() => this.fetchDataLogExport({ page: 1, month: this.state.filterMonth, year: this.state.filterYear })}
            className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
          >
            {"<<"}
          </a>
        );
        akhirLogExport = (
          <a
            href={() => false}
            onClick={() => this.fetchDataLogExport({ page: data.last_page, month: this.state.filterMonth, year: this.state.filterYear })}
            className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
          >
            {">>"}
          </a>
        );
      }
      this.setState({ awalLogExport, sebelumLogExport, halLogExport, setelahLogExport, akhirLogExport });
    };

    tombolAksiLogExport = (cell, row) => {
      return (
        <>
          <Button
            size="xs"
            color="info"
            className="btn-icon"
            title="Detail Log"
            onClick={() => {
              this.setState({
                loadingDetailLogExport: true,
              })
              this.detailDataLogExport(row)
            }}
          >
            <i className="fa fa-eye"></i>
          </Button>{" "}
        </>
      );
    };
  // END LOG Export


	componentDidMount() {
    this._isMounted = true;
    this.fetchDataLogBSRE({ page: null, where: [], month: this.state.filterMonth, year: this.state.filterYear });
    this.fetchDataLogExport({ page: null, where: [], month: this.state.filterMonth, year: this.state.filterYear });
	}

  componentWillUnmount() {
    this._isMounted = false;
  }

  // CARI DATA
  cariData = e => {
    if (e.key === 'Enter') {
      this.setState({ 
				loading: true, 
				textCari: e.target.value 
			})

      setTimeout(
        function() {
          if(this.state.active_tab_vertical === '1'){
            this.fetchDataLogBSRE({ page: null, where: [], month: this.state.filterMonth, year: this.state.filterYear });
          }
          else if(this.state.active_tab_vertical === '2'){
            this.fetchDataLogExport({ page: null, where: [], month: this.state.filterMonth, year: this.state.filterYear });
          }
        }.bind(this),
        500
      );
    }
  }

  // FILTER DATA
  filterFetch = (date) => {
		if (typeof date.isValid !== 'undefined' && date._isValid) {
			this.setState({ 
				filterData: date.format('YYYY/MM'),
				filterMonth: date.format('MM'),
				filterYear: date.format('YYYY'),
			})

      if(this.state.active_tab_vertical === '1'){
			  this.fetchDataLogBSRE({ page: null, where: [], month: date.format('MM'), year: date.format('YYYY')});
      } else if(this.state.active_tab_vertical === '2'){
			  this.fetchDataLogExport({ page: null, where: [], month: date.format('MM'), year: date.format('YYYY')});
      }
			this.forceUpdate()
		} 
	}

	render() {
    // DATA KODE SURAT
      var dataLogBSRE = this.state.dataLogBSRE;
      var detailDataLogBSRE = this.state.detailDataLogBSRE;
      let userLog = null;
      let paramsLog = null;
      var dataLogExport = this.state.dataLogExport;

      if(detailDataLogBSRE){
        userLog = JSON.parse(detailDataLogBSRE.user)
      }
      if(detailDataLogBSRE){
        paramsLog = JSON.parse(detailDataLogBSRE.params)
      }

      const columnsLogBSRE = [
        {
          dataField: "no",
          text: "No",
          headerAlign: 'center',
          align: 'center',
          formatter: (key, obj, index) =>{          
              let current_pagenum = this.state.paginationLogBSRE.current_page;
              let total_records_per_page = this.state.paginationLogBSRE.per_page;
              let row_index = (index+1);
              let serial_num = ((total_records_per_page*(current_pagenum-1))+row_index);
              return serial_num; 
          }
        },
        {
          dataField: "tanggal_surat",
          headerAlign: 'center',
          align: 'center',
          text: "Tanggal",
          formatter: (cell, obj) => {
            let plainTime = '-'
            if (obj.created_at) {
              let date = new Date(obj.created_at)
              date = date.toLocaleString('id-ID')
              
              const datetime = date.split(' ')
              
    
              date = datetime[0]
              let time = datetime[1]
    
              const splitDate = date.split('/')
              time = time.replaceAll('.', ':')
    
              const list_bulan = [
                'Januari',
                'Februari',
                'Maret',
                'April',
                'Mei',
                'Juni',
                'Juli',
                'Agustus',
                'September',
                'Oktober',
                'November',
                'Desember'
              ];
  
              plainTime = `${splitDate[0]} ${list_bulan[parseInt(splitDate[1]) - 1]} ${splitDate[2]}  ${time}`;
            }
  
            return plainTime
          },
          isDummyField: true,
          sort: true
        },
        {
          dataField: "method",
          text: "Method",
          headerAlign: 'center',
          align: 'center',
          sort: true
        },
        {
          dataField: "response_code",
          text: "Response Code",
          headerAlign: 'center',
          align: 'center',
          sort: true,
        },
        {
          dataField: "route",
          text: "Route",
          headerAlign: 'center',
          align: 'center',
          sort: true
        },
        {
          dataField: "ip_address",
          text: "IP Address",
          headerAlign: 'center',
          align: 'center',
          sort: true
        },
        {
          dataField: "user",
          text: "User",
          headerAlign: 'center',
          align: 'center',
          sort: true,
          formatter: (key, obj, index) =>{          
            let pars = JSON.parse(obj.user);
            let username = pars.username;
            
            return username; 
        }
        },
        {
          dataField: "aksi",
          text: "Aksi",
          headerAlign: 'center',
          align: 'center',
          style: {
            width: '150px'
          },
          formatter: this.tombolAksiLogBSRE
        }
      ];

      const columnsLogExport = [
        {
          dataField: "no",
          text: "No",
          headerAlign: 'center',
          align: 'center',
          formatter: (key, obj, index) =>{          
              let current_pagenum = this.state.paginationLogExport.current_page;
              let total_records_per_page = this.state.paginationLogExport.per_page;
              let row_index = (index+1);
              let serial_num = ((total_records_per_page*(current_pagenum-1))+row_index);
              return serial_num; 
          }
        },
        {
          dataField: "tanggal_surat",
          headerAlign: 'center',
          align: 'center',
          text: "Tanggal",
          formatter: (cell, obj) => {
            let plainTime = '-'
            if (obj.created_at) {
              let date = new Date(obj.created_at)
              date = date.toLocaleString('id-ID')
              
              const datetime = date.split(' ')
              
    
              date = datetime[0]
              let time = datetime[1]
    
              const splitDate = date.split('/')
              time = time.replaceAll('.', ':')
    
              const list_bulan = [
                'Januari',
                'Februari',
                'Maret',
                'April',
                'Mei',
                'Juni',
                'Juli',
                'Agustus',
                'September',
                'Oktober',
                'November',
                'Desember'
              ];
  
              plainTime = `${splitDate[0]} ${list_bulan[parseInt(splitDate[1]) - 1]} ${splitDate[2]}  ${time}`;
            }
  
            return plainTime
          },
          isDummyField: true,
          sort: true
        },
        {
          dataField: "data_pengguna",
          text: "Pengguna",
          headerAlign: 'center',
          align: 'center',
          formatter: (cell, obj) => {
            let showData = ''
            if (obj.data_pengguna && obj.data_pengguna.nama) {
              showData = obj.data_pengguna.nama 
            }
            else{
              showData = obj.data_pengguna.username
            }
  
            return showData
          },
          isDummyField: true,
          sort: true
        },
        {
          dataField: "email",
          text: "Email",
          headerAlign: 'center',
          align: 'center',
          sort: true,
        },
        // {
        //   dataField: "aksi",
        //   text: "Aksi",
        //   headerAlign: 'center',
        //   align: 'center',
        //   style: {
        //     width: '150px'
        //   },
        //   formatter: this.tombolAksiLogExport
        // }
      ];

		return (
			<div>
				{/* <Breadcrumb title="Data Profile" parent="Admin"/> */}
				<SweetAlert
					show={this.state.show}
					type={this.state.basicType}
					title={this.state.basicTitle}
					confirmBtnBsStyle="success"
					onConfirm={this.closeAlert}
				>
					{this.state.pesanAlert}
				</SweetAlert>

        <SweetAlert
					show={this.state.loadingPreview}
					showCancel = {false}
					showConfirm={false}
				>
					<div align="center">
						<h5 className="modal-title" style={{ textAlign: "center", color: 'black' }}>Sedang memuat data...</h5>
						<br/>
						<img 
							alt="loading"
							src={require("../../../assets/images/tes-loading.gif")} 
							style={{
								// width: "100%",
								borderRadius: "10px",
								width: '150px'
							}}
						/> 
						<br/><br/>
					</div>
				</SweetAlert>

				{this.state.alert}
				
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-12">
                    <div className="card mb-0">
                        <div className="card-header">
                        <div className="row">
                            <div className="col-lg-3">
                              <Nav  className={'nav flex-column nav-pills'}>
                                <NavItem>
                                  <NavLink className={classnames({ active: this.state.active_tab_vertical === '1' })}
                                      onClick={() => { this.toggle_vertical('1'); }}>
                                    Log TTD BSRE
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink className={classnames({ active: this.state.active_tab_vertical === '2' })}
                                      onClick={() => { this.toggle_vertical('2'); }}>
                                    Log Export by Email
                                  </NavLink>
                                </NavItem>
                              </Nav>
                            </div>
                            <div className="col-lg-9">
                              <TabContent activeTab={this.state.active_tab_vertical}>
                                <TabPane tabId="1">
                                  <Row>
                                    <Col sm="12">
                                      <div className="row">
                                      {
                                        this.state.statDetailLogBSRE?
                                          <div className="col-sm-12">
                                            <div style={{ marginTop: 15 }}>
                                              <Row>
                                                <Col sm="12">
                                                  {/* =========================== */}
                                                  <div className="card mb-0">
                                                    <div className="card-header">
                                                      <div className="row">
                                                        <div className="col-sm-12">
                                                          {/* <h5>{this.state.detailDataLogBSRE?this.state.detailDataLogBSRE.nama:''}</h5> */}
                                                        </div>
                                                        <div className="col-sm-12">
                                                          <br/>
                                                        </div>
                                                        <div className="col-sm-6">
                                                          <button onClick={() => { 
                                                            this.setState({ 
                                                              statDetailLogBSRE: false,
                                                              detailDataLogBSRE: null,
                                                              active_tab_icon: '1',
                                                            });
                                                          }}
                                                          color="primary" className="btn btn-secondary"><i className="fa fa-arrow-left"></i> Kembali</button>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="card-body datatable-react">
                                                      {this.state.loadingDetailLogBSRE ? (
                                                        <div className="row">
                                                          <div className="col-sm-12" align="center">
                                                            <img
                                                              alt="loading"
                                                              src={require("../../../assets/images/tes-loading.gif")}
                                                              style={{
                                                                borderRadius: "10px",
                                                                width: '100px'
                                                              }} />
                                                          </div>
                                                        </div>
                                                      ) : detailDataLogBSRE ? (
                                                        <>
                                                          <div style={{textAlign:'center'}}>
                                                            <h5>Detail Log</h5>
                                                            <br/>
                                                          </div>
                                                          <div className="card-body datatable-react" align='center'>
                                                            <table className="table table-bordered table-stripes table-hovered">
                                                              <thead>
                                                                <tr>
                                                                  <td style={{ padding: '5px 5px 5px 5px'}}><b>Tanggal</b></td>
                                                                  <td style={{ padding: '5px 5px 5px 5px'}}>
                                                                    {new Date(detailDataLogBSRE.created_at).toLocaleString('id-ID')}
                                                                  </td>
                                                                </tr>
                                                                <tr>
                                                                  <td style={{ padding: '5px 5px 5px 5px'}}><b>Method</b></td>
                                                                  <td style={{ padding: '5px 5px 5px 5px'}}>{detailDataLogBSRE.method}</td>
                                                                </tr>
                                                                <tr>
                                                                  <td style={{ padding: '5px 5px 5px 5px'}}><b>Response Code</b></td>
                                                                  <td style={{ padding: '5px 5px 5px 5px' }}>{detailDataLogBSRE.response_code}</td>
                                                                </tr>
                                                                <tr>
                                                                  <td style={{ padding: '5px 5px 5px 5px' }}><b>Route</b></td>
                                                                  <td style={{ padding: '5px 5px 5px 5px' }}>{detailDataLogBSRE.route}</td>
                                                                </tr>
                                                                <tr>
                                                                  <td style={{ padding: '5px 5px 5px 5px' }}><b>IP Address</b></td>
                                                                  <td style={{ padding: '5px 5px 5px 5px' }}>{detailDataLogBSRE.ip_address}</td>
                                                                </tr>
                                                                <tr>
                                                                  <td style={{ padding: '5px 5px 5px 5px' }}><b>User</b></td>
                                                                  <td style={{ padding: '5px 5px 5px 5px' }}>{userLog.username}</td>
                                                                </tr>
                                                                <tr>
                                                                  <td style={{ padding: '5px 5px 5px 5px' }}><b>User Agent</b></td>
                                                                  <td style={{ padding: '5px 5px 5px 5px' }}>{detailDataLogBSRE.user_agent}</td>
                                                                </tr>
                                                                <tr>
                                                                  <td style={{ padding: '5px 5px 5px 5px' }}><b>Response</b></td>
                                                                  <td style={{ padding: '5px 5px 5px 5px' }}>{detailDataLogBSRE.response}</td>
                                                                </tr>
                                                                <tr>
                                                                  <td style={{ padding: '5px 5px 5px 5px' }}><b>Params</b></td>
                                                                  <td style={{ padding: '5px 5px 5px 5px' }}>
                                                                    <table className="table table-bordered table-stripes table-hovered">
                                                                      <tr>
                                                                        <td><b>Nik</b></td>
                                                                        <td>{paramsLog.nik?paramsLog.nik:'-'}</td>
                                                                      </tr>
                                                                      <tr>
                                                                        <td><b>Pass</b></td>
                                                                        <td>{paramsLog.pass?paramsLog.pass:'-'}</td>
                                                                      </tr>
                                                                      <tr>
                                                                        <td><b>Height</b></td>
                                                                        <td>{paramsLog.height?paramsLog.height:'-'}</td>
                                                                      </tr>
                                                                      <tr>
                                                                        <td><b>Width</b></td>
                                                                        <td>{paramsLog.width?paramsLog.width:'-'}</td>
                                                                      </tr>
                                                                      <tr>
                                                                        <td><b>Tag Koordinat</b></td>
                                                                        <td>{paramsLog.tag_koordinat?paramsLog.tag_koordinat:'-'}</td>
                                                                      </tr>
                                                                      <tr>
                                                                        <td><b>Tampilan</b></td>
                                                                        <td>{paramsLog.tampilan?paramsLog.tampilan:'-'}</td>
                                                                      </tr>
                                                                      <tr>
                                                                        <td><b>Link QR</b></td>
                                                                        <td>{paramsLog.linkQr?paramsLog.linkQr:'-'}</td>
                                                                      </tr>
                                                                      <tr>
                                                                        <td><b>PDF</b></td>
                                                                        <td>{paramsLog.pdf?paramsLog.pdf:'-'}</td>
                                                                      </tr>
                                                                      <tr>
                                                                        <td><b>ImageTTD</b></td>
                                                                        <td>{paramsLog.imageTTD?paramsLog.imageTTD:'-'}</td>
                                                                      </tr>
                                                                      <tr>
                                                                        <td><b>Page</b></td>
                                                                        <td>{paramsLog.page?paramsLog.page:'-'}</td>
                                                                      </tr>
                                                                      <tr>
                                                                        <td><b>xAxis</b></td>
                                                                        <td>{paramsLog.xAxis?paramsLog.xAxis:'-'}</td>
                                                                      </tr>
                                                                      <tr>
                                                                        <td><b>yAxis</b></td>
                                                                        <td>{paramsLog.yAxis?paramsLog.yAxis:'-'}</td>
                                                                      </tr>
                                                                    </table>
                                                                  </td>
                                                                </tr>
                                                              </thead>
                                                              <tbody>
                                                                <tr>
                                                                </tr>
                                                              
                                                              </tbody>
                                                            </table>
                                                          </div>
                                                        </>
                                                      ) : (
                                                        <h6 className="text-center mb-2 mt-2">Belum ada data</h6>
                                                      )}
                                                    </div>
                                                  </div>
                                                  {/* =========================== */}
                                                </Col>
                                              </Row>
                                            </div> 
                                          </div>
                                        :
                                          <div className="col-sm-12">
                                            <div className="card mb-0">
                                              <div className="card-header">
                                                <div className="row">
                                                  <div className="col-sm-6">
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      id="cariTable"
                                                      placeholder="Cari..."
                                                      onKeyPress={this.cariData}
                                                    />
                                                  </div>
                                                  <div className="col-sm-6">
                                                    <Datetime
                                                      inputProps={{ placeholder: 'Pilih Bulan dan Tahun', required: true }}
                                                      inputId="tanggal"
                                                      name="tanggal"
                                                      locale="id-ID"
                                                      timeFormat={false}
                                                      dateFormat="YYYY/MM"
                                                      // input={true}
                                                      closeOnTab={true}
                                                      closeOnSelect={true}
                                                      initialValue={new Date()}
                                                      value={this.state.filterData}
                                                      onChange={(e) => {
                                                        this.filterFetch(e);
                                                      }}
                                                    />
                                                  </div>
                                                  <div className="col-sm-6 text-right" style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="card-body datatable-react">
                                                {this.state.loadingLogBSRE ? (
                                                  <div className="row">
                                                    <div className="col-sm-12" align="center">
                                                      <img
                                                        alt="loading"
                                                        src={require("../../../assets/images/tes-loading.gif")}
                                                        style={{
                                                          borderRadius: "10px",
                                                          width: '100px'
                                                        }} />
                                                    </div>
                                                  </div>
                                                ) : dataLogBSRE.length > 0 ? (
                                                  <>
                                                    <BootstrapTable keyField="id" data={dataLogBSRE} columns={columnsLogBSRE} />
                                                    <div className="pull-right text-white">
                                                      {this.state.awalLogBSRE}
                                                      {this.state.sebelumLogBSRE}
                                                      {this.state.halLogBSRE.map(dt => {
                                                        return dt;
                                                      })}
                                                      {this.state.setelahLogBSRE}
                                                      {this.state.akhirLogBSRE}
                                                    </div>
                                                  </>
                                                ) : (
                                                  <h6 className="text-center mb-2 mt-2">Belum ada data</h6>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                      }
                                      </div>
                                      <br />
                                    </Col>
                                  </Row>
                                </TabPane>
                                <TabPane tabId="2">
                                  <Row>
                                    <Col sm="12">
                                      <div className="row">
                                      {
                                        this.state.statDetailLogBSRE?
                                          <div className="col-sm-12">
                                            <div style={{ marginTop: 15 }}>
                                              <Row>
                                                <Col sm="12">
                                                  {/* =========================== */}
                                                  <div className="card mb-0">
                                                    <div className="card-header">
                                                      <div className="row">
                                                        <div className="col-sm-12">
                                                          {/* <h5>{this.state.detailDataLogBSRE?this.state.detailDataLogBSRE.nama:''}</h5> */}
                                                        </div>
                                                        <div className="col-sm-12">
                                                          <br/>
                                                        </div>
                                                        <div className="col-sm-6">
                                                          <button onClick={() => { 
                                                            this.setState({ 
                                                              statDetailLogBSRE: false,
                                                              detailDataLogBSRE: null,
                                                              active_tab_icon: '1',
                                                            });
                                                          }}
                                                          color="primary" className="btn btn-secondary"><i className="fa fa-arrow-left"></i> Kembali</button>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="card-body datatable-react">
                                                      {this.state.loadingDetailLogBSRE ? (
                                                        <div className="row">
                                                          <div className="col-sm-12" align="center">
                                                            <img
                                                              alt="loading"
                                                              src={require("../../../assets/images/tes-loading.gif")}
                                                              style={{
                                                                borderRadius: "10px",
                                                                width: '100px'
                                                              }} />
                                                          </div>
                                                        </div>
                                                      ) : detailDataLogBSRE ? (
                                                        <>
                                                          <div style={{textAlign:'center'}}>
                                                            <h5>Detail Log</h5>
                                                            <br/>
                                                          </div>
                                                          <div className="card-body datatable-react" align='center'>
                                                            <table className="table table-bordered table-stripes table-hovered">
                                                              <thead>
                                                                <tr>
                                                                  <td style={{ padding: '5px 5px 5px 5px'}}><b>Tanggal</b></td>
                                                                  <td style={{ padding: '5px 5px 5px 5px'}}>
                                                                    {new Date(detailDataLogBSRE.created_at).toLocaleString('id-ID')}
                                                                  </td>
                                                                </tr>
                                                                <tr>
                                                                  <td style={{ padding: '5px 5px 5px 5px'}}><b>Method</b></td>
                                                                  <td style={{ padding: '5px 5px 5px 5px'}}>{detailDataLogBSRE.method}</td>
                                                                </tr>
                                                                <tr>
                                                                  <td style={{ padding: '5px 5px 5px 5px'}}><b>Response Code</b></td>
                                                                  <td style={{ padding: '5px 5px 5px 5px' }}>{detailDataLogBSRE.response_code}</td>
                                                                </tr>
                                                                <tr>
                                                                  <td style={{ padding: '5px 5px 5px 5px' }}><b>Route</b></td>
                                                                  <td style={{ padding: '5px 5px 5px 5px' }}>{detailDataLogBSRE.route}</td>
                                                                </tr>
                                                                <tr>
                                                                  <td style={{ padding: '5px 5px 5px 5px' }}><b>IP Address</b></td>
                                                                  <td style={{ padding: '5px 5px 5px 5px' }}>{detailDataLogBSRE.ip_address}</td>
                                                                </tr>
                                                                <tr>
                                                                  <td style={{ padding: '5px 5px 5px 5px' }}><b>User</b></td>
                                                                  <td style={{ padding: '5px 5px 5px 5px' }}>{userLog.username}</td>
                                                                </tr>
                                                                <tr>
                                                                  <td style={{ padding: '5px 5px 5px 5px' }}><b>User Agent</b></td>
                                                                  <td style={{ padding: '5px 5px 5px 5px' }}>{detailDataLogBSRE.user_agent}</td>
                                                                </tr>
                                                                <tr>
                                                                  <td style={{ padding: '5px 5px 5px 5px' }}><b>Response</b></td>
                                                                  <td style={{ padding: '5px 5px 5px 5px' }}>{detailDataLogBSRE.response}</td>
                                                                </tr>
                                                                <tr>
                                                                  <td style={{ padding: '5px 5px 5px 5px' }}><b>Params</b></td>
                                                                  <td style={{ padding: '5px 5px 5px 5px' }}>
                                                                    <table className="table table-bordered table-stripes table-hovered">
                                                                      <tr>
                                                                        <td><b>Nik</b></td>
                                                                        <td>{paramsLog.nik?paramsLog.nik:'-'}</td>
                                                                      </tr>
                                                                      <tr>
                                                                        <td><b>Pass</b></td>
                                                                        <td>{paramsLog.pass?paramsLog.pass:'-'}</td>
                                                                      </tr>
                                                                      <tr>
                                                                        <td><b>Height</b></td>
                                                                        <td>{paramsLog.height?paramsLog.height:'-'}</td>
                                                                      </tr>
                                                                      <tr>
                                                                        <td><b>Width</b></td>
                                                                        <td>{paramsLog.width?paramsLog.width:'-'}</td>
                                                                      </tr>
                                                                      <tr>
                                                                        <td><b>Tag Koordinat</b></td>
                                                                        <td>{paramsLog.tag_koordinat?paramsLog.tag_koordinat:'-'}</td>
                                                                      </tr>
                                                                      <tr>
                                                                        <td><b>Tampilan</b></td>
                                                                        <td>{paramsLog.tampilan?paramsLog.tampilan:'-'}</td>
                                                                      </tr>
                                                                      <tr>
                                                                        <td><b>Link QR</b></td>
                                                                        <td>{paramsLog.linkQr?paramsLog.linkQr:'-'}</td>
                                                                      </tr>
                                                                      <tr>
                                                                        <td><b>PDF</b></td>
                                                                        <td>{paramsLog.pdf?paramsLog.pdf:'-'}</td>
                                                                      </tr>
                                                                      <tr>
                                                                        <td><b>ImageTTD</b></td>
                                                                        <td>{paramsLog.imageTTD?paramsLog.imageTTD:'-'}</td>
                                                                      </tr>
                                                                      <tr>
                                                                        <td><b>Page</b></td>
                                                                        <td>{paramsLog.page?paramsLog.page:'-'}</td>
                                                                      </tr>
                                                                      <tr>
                                                                        <td><b>xAxis</b></td>
                                                                        <td>{paramsLog.xAxis?paramsLog.xAxis:'-'}</td>
                                                                      </tr>
                                                                      <tr>
                                                                        <td><b>yAxis</b></td>
                                                                        <td>{paramsLog.yAxis?paramsLog.yAxis:'-'}</td>
                                                                      </tr>
                                                                    </table>
                                                                  </td>
                                                                </tr>
                                                              </thead>
                                                              <tbody>
                                                                <tr>
                                                                </tr>
                                                              
                                                              </tbody>
                                                            </table>
                                                          </div>
                                                        </>
                                                      ) : (
                                                        <h6 className="text-center mb-2 mt-2">Belum ada data</h6>
                                                      )}
                                                    </div>
                                                  </div>
                                                  {/* =========================== */}
                                                </Col>
                                              </Row>
                                            </div> 
                                          </div>
                                        :
                                          <div className="col-sm-12">
                                            <div className="card mb-0">
                                              <div className="card-header">
                                                <div className="row">
                                                  <div className="col-sm-6">
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      id="cariTable"
                                                      placeholder="Cari..."
                                                      onKeyPress={this.cariData}
                                                    />
                                                  </div>
                                                  <div className="col-sm-6">
                                                    <Datetime
                                                      inputProps={{ placeholder: 'Pilih Bulan dan Tahun', required: true }}
                                                      inputId="tanggal"
                                                      name="tanggal"
                                                      locale="id-ID"
                                                      timeFormat={false}
                                                      dateFormat="YYYY/MM"
                                                      // input={true}
                                                      closeOnTab={true}
                                                      closeOnSelect={true}
                                                      initialValue={new Date()}
                                                      value={this.state.filterData}
                                                      onChange={(e) => {
                                                        this.filterFetch(e);
                                                      }}
                                                    />
                                                  </div>
                                                  <div className="col-sm-6 text-right" style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="card-body datatable-react">
                                                {this.state.loadingLogExport ? (
                                                  <div className="row">
                                                    <div className="col-sm-12" align="center">
                                                      <img
                                                        alt="loading"
                                                        src={require("../../../assets/images/tes-loading.gif")}
                                                        style={{
                                                          borderRadius: "10px",
                                                          width: '100px'
                                                        }} />
                                                    </div>
                                                  </div>
                                                ) : dataLogExport.length > 0 ? (
                                                  <>
                                                    <BootstrapTable keyField="id" data={dataLogExport} columns={columnsLogExport} />
                                                    <div className="pull-right text-white">
                                                      {this.state.awalLogExport}
                                                      {this.state.sebelumLogExport}
                                                      {this.state.halLogExport.map(dt => {
                                                        return dt;
                                                      })}
                                                      {this.state.setelahLogExport}
                                                      {this.state.akhirLogExport}
                                                    </div>
                                                  </>
                                                ) : (
                                                  <h6 className="text-center mb-2 mt-2">Belum ada data</h6>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                      }
                                      </div>
                                      <br />
                                    </Col>
                                  </Row>
                                </TabPane>
                              </TabContent>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
			</div>
		);
	}
}

export default BasicTable;